import styles from "./index.module.scss";
import { Badge } from "react-bootstrap";
import CustomAnimatedNumber from "../CustomAnimatedNumber";

const Pin = ({
  topCaption = "",
  leftSideText = "",
  rightSideText = "",
  onClick = () => undefined,
  width = 109,
  isAnimatedNumber = true,
  smallFont = false,
}) => {
  return (
    <div className={styles.parent} style={{ width: width }}>
      <span className={styles.caption}>{topCaption}</span>
      <Badge
        className={`${styles.lightTextBadge} ${styles.badge} ${
          styles.hoverable
        } ${styles.left} ${smallFont ? styles.smallFont : null}`}
        bg="success"
        onClick={onClick}
      >
        {leftSideText}
        <div className={styles.rightSide}>
          {isAnimatedNumber ? (
            <CustomAnimatedNumber delay={500} value={rightSideText} />
          ) : (
            rightSideText
          )}
        </div>
      </Badge>
    </div>
  );
};

export default Pin;
